import React, { useMemo } from 'react';
import { apiHolder as api, apis } from 'api';
import { FLOLDER } from '../../../constant';
import ReadListIcons from '@web-common/components/UI/Icons/svgs/ReadListSvgs';
import cloneDeep from 'lodash/cloneDeep';
import { Tooltip } from 'antd';
import { getIn18Text } from 'api';
const eventApi = api.api.getEventApi();
const mailConfApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const MyTooltip = props => {
    const { type, wrapClass = '', handleIconClick = () => { } } = props;
    const className = 'from-flag-warp-svg' + `${wrapClass ? ' ' + wrapClass : ''}`;
    if (!type) {
        return (React.createElement("span", { className: className, onClick: handleIconClick }, props.children));
    }
    const title = getIn18Text(type);
    return (React.createElement(Tooltip, { title: title, mouseEnterDelay: 0.3, mouseLeaveDelay: 0.15 },
        React.createElement("span", { className: className, onClick: handleIconClick }, props.children)));
};
const filterArr = (originalData, filterConfig) => {
    const res = [];
    originalData.forEach((icon) => {
        if (filterConfig.includes(icon)) {
            res.push(icon);
        }
    });
    let _res = [...new Set(res)];
    return _res;
};
const sortArr = (originalData, filterConfig) => {
    const _originalData = cloneDeep(originalData);
    let res = [];
    filterConfig.forEach((icon) => {
        if (_originalData.includes(icon)) {
            res.push(icon);
            _originalData.splice(_originalData.indexOf(icon), 1);
        }
    });
    res = res.concat(_originalData);
    return res;
};
export var MAIL_STATE_ICON;
(function (MAIL_STATE_ICON) {
    MAIL_STATE_ICON["PRIORITY"] = "PRIORITY";
    MAIL_STATE_ICON["SYSTEM"] = "SYSTEM";
    MAIL_STATE_ICON["UNREAD"] = "UNREAD";
    MAIL_STATE_ICON["REPLAYED"] = "REPLAYED";
    MAIL_STATE_ICON["FORWARDED"] = "FORWARDED";
    MAIL_STATE_ICON["REPLAYED_AND_FORWARDED"] = "REPLAYED_AND_FORWARDED";
    MAIL_STATE_ICON["POPREAD"] = "POPREAD";
    MAIL_STATE_ICON["RCPT_SUCCEED"] = "RCPT_SUCCEED";
    MAIL_STATE_ICON["PARTIAL_RCPT_SUCCEED"] = "PARTIAL_RCPT_SUCCEED";
    MAIL_STATE_ICON["RCPT_FAILED"] = "RCPT_FAILED";
    MAIL_STATE_ICON["WITHDRAW_SUCC"] = "WITHDRAW_SUCC";
    MAIL_STATE_ICON["PARTIAL_WITHDRAW_SUCC"] = "PARTIAL_WITHDRAW_SUCC";
    MAIL_STATE_ICON["WITHDRAW_FAIL"] = "WITHDRAW_FAIL";
    MAIL_STATE_ICON["SUSPICIOUS_MAIL"] = "SUSPICIOUS_MAIL";
})(MAIL_STATE_ICON || (MAIL_STATE_ICON = {}));
const iconConfig = {
    [MAIL_STATE_ICON.PRIORITY]: {
        show: (data) => {
            const { priority } = data.entry || {};
            return typeof priority === 'number' && priority < 2;
        },
        icon: (active) => {
            return React.createElement(ReadListIcons.AlarmSvg, null);
        },
        tooltip: 'JINJIYOUJIAN',
    },
    [MAIL_STATE_ICON.SYSTEM]: {
        show: (data) => {
            const { system } = data.entry || {};
            return system;
        },
        icon: React.createElement(ReadListIcons.SystemSvg, null),
        tooltip: 'WANGYIXITONGYOUJIAN',
    },
    [MAIL_STATE_ICON.UNREAD]: {
        show: (data) => {
            const { readStatus } = data.entry || {};
            const { isTpMail } = data;
            return readStatus === 'unread' && !isTpMail;
        },
        icon: React.createElement("div", { className: "dot" }),
        tooltip: '',
    },
    [MAIL_STATE_ICON.REPLAYED]: {
        show: (data) => {
            const { replayed, forwarded } = data.entry || {};
            return replayed && !forwarded;
        },
        icon: React.createElement(ReadListIcons.ReplyFullActiveSvg, null),
        tooltip: 'YIHUIFU',
    },
    [MAIL_STATE_ICON.FORWARDED]: {
        show: (data) => {
            const { replayed, forwarded } = data.entry || {};
            return forwarded && !replayed;
        },
        icon: React.createElement(ReadListIcons.ForwardedSvg, null),
        tooltip: 'YIZHUANFA',
    },
    [MAIL_STATE_ICON.REPLAYED_AND_FORWARDED]: {
        show: (data) => {
            const { replayed, forwarded } = data.entry || {};
            return replayed && forwarded;
        },
        icon: React.createElement(ReadListIcons.ReplayedForwardedSvg, null),
        tooltip: 'HUIFUQIEZHUANFA',
    },
    [MAIL_STATE_ICON.POPREAD]: {
        show: (data) => {
            const { readStatus, popRead } = data.entry || {};
            return readStatus === 'unread' && popRead;
        },
        icon: React.createElement(ReadListIcons.PopSvg, null),
        tooltip: 'POP',
    },
    [MAIL_STATE_ICON.RCPT_SUCCEED]: {
        show: (data) => {
            const { rcptSucceed, rcptFailed } = data.entry || {};
            return rcptSucceed && !rcptFailed;
        },
        icon: React.createElement(ReadListIcons.RcptSuccSvg, null),
        tooltip: 'FASONGCHENGGONG',
    },
    [MAIL_STATE_ICON.PARTIAL_RCPT_SUCCEED]: {
        show: (data) => {
            const { rcptSucceed, rcptFailed } = data.entry || {};
            return rcptSucceed && rcptFailed;
        },
        icon: React.createElement(ReadListIcons.PartialRcptSuccSvg, null),
        tooltip: 'BUFENFASONGCHENGGONG',
    },
    [MAIL_STATE_ICON.RCPT_FAILED]: {
        show: (data) => {
            const { rcptSucceed, rcptFailed } = data.entry || {};
            return rcptFailed && !rcptSucceed;
        },
        icon: React.createElement(ReadListIcons.RcptFailSvg, null),
        tooltip: 'FASONGSHIBAI',
    },
    [MAIL_STATE_ICON.WITHDRAW_SUCC]: {
        show: (data) => {
            const { rclStatus } = data.entry || {};
            return rclStatus === 3;
        },
        icon: React.createElement(ReadListIcons.WithdrawSuccSvg, null),
        tooltip: 'CHEHUICHENGGONG',
    },
    [MAIL_STATE_ICON.PARTIAL_WITHDRAW_SUCC]: {
        show: (data) => {
            const { rclStatus } = data.entry || {};
            return rclStatus === 5;
        },
        icon: React.createElement(ReadListIcons.PartialWithdrawSuccSvg, null),
        tooltip: 'BUFENCHEHUICHENGGONG',
    },
    [MAIL_STATE_ICON.WITHDRAW_FAIL]: {
        show: (data) => {
            const { rclStatus } = data.entry || {};
            return rclStatus === 4;
        },
        icon: React.createElement(ReadListIcons.WithdrawFailSvg, null),
        tooltip: 'CHEHUISHIBAI',
    },
    [MAIL_STATE_ICON.SUSPICIOUS_MAIL]: {
        show: (data) => {
            const { suspiciousSpam } = data.entry || {};
            return !!suspiciousSpam;
        },
        icon: (active) => {
            return React.createElement(ReadListIcons.SuspiciousSvg, null);
        },
        tooltip: 'KEYIYOUJIAN',
    },
};
const filterIconListByFid = (folder, iconList) => {
    if ([FLOLDER.SENT].includes(folder)) {
        const sendFidIcon = [
            MAIL_STATE_ICON.PRIORITY,
            MAIL_STATE_ICON.RCPT_SUCCEED,
            MAIL_STATE_ICON.PARTIAL_RCPT_SUCCEED,
            MAIL_STATE_ICON.RCPT_FAILED,
            MAIL_STATE_ICON.WITHDRAW_SUCC,
            MAIL_STATE_ICON.PARTIAL_WITHDRAW_SUCC,
            MAIL_STATE_ICON.WITHDRAW_FAIL,
        ];
        return filterArr(iconList, sendFidIcon);
    }
    else if ([FLOLDER.DRAFT].includes(folder)) {
        const otherFidIcon = [MAIL_STATE_ICON.PRIORITY];
        return filterArr(iconList, otherFidIcon);
    }
    const otherFidIcon = [
        MAIL_STATE_ICON.PRIORITY,
        MAIL_STATE_ICON.SYSTEM,
        MAIL_STATE_ICON.UNREAD,
        MAIL_STATE_ICON.REPLAYED,
        MAIL_STATE_ICON.FORWARDED,
        MAIL_STATE_ICON.REPLAYED_AND_FORWARDED,
        MAIL_STATE_ICON.POPREAD,
        MAIL_STATE_ICON.SUSPICIOUS_MAIL,
    ];
    return filterArr(iconList, otherFidIcon);
};
const filterIconListByMailState = (data, iconList) => {
    const res = iconList.filter((icon) => {
        return !!iconConfig[icon].show(data);
    });
    return res;
};
const sortIconListByPriority = (folder, iconList) => {
    if ([FLOLDER.SENT].includes(folder)) {
        const sendFilePriority = [
            MAIL_STATE_ICON.PRIORITY,
            MAIL_STATE_ICON.WITHDRAW_FAIL,
            MAIL_STATE_ICON.PARTIAL_WITHDRAW_SUCC,
            MAIL_STATE_ICON.WITHDRAW_SUCC,
            MAIL_STATE_ICON.RCPT_FAILED,
            MAIL_STATE_ICON.PARTIAL_RCPT_SUCCEED,
            MAIL_STATE_ICON.RCPT_SUCCEED,
        ];
        return sortArr(iconList, sendFilePriority);
    }
    const otherFilePriority = [
        MAIL_STATE_ICON.UNREAD,
        MAIL_STATE_ICON.SUSPICIOUS_MAIL,
        MAIL_STATE_ICON.PRIORITY,
        MAIL_STATE_ICON.SYSTEM,
        MAIL_STATE_ICON.REPLAYED_AND_FORWARDED,
        MAIL_STATE_ICON.REPLAYED,
        MAIL_STATE_ICON.FORWARDED,
        MAIL_STATE_ICON.POPREAD,
    ];
    return sortArr(iconList, otherFilePriority);
};
const filterIconByMutex = (iconList) => {
    const _iconList = [...new Set(iconList)];
    const mutexconfig = [
        [
            MAIL_STATE_ICON.WITHDRAW_FAIL,
            MAIL_STATE_ICON.PARTIAL_WITHDRAW_SUCC,
            MAIL_STATE_ICON.WITHDRAW_SUCC,
            MAIL_STATE_ICON.RCPT_FAILED,
            MAIL_STATE_ICON.PARTIAL_RCPT_SUCCEED,
            MAIL_STATE_ICON.RCPT_SUCCEED,
        ],
        [MAIL_STATE_ICON.REPLAYED, MAIL_STATE_ICON.FORWARDED, MAIL_STATE_ICON.REPLAYED_AND_FORWARDED],
        [MAIL_STATE_ICON.PRIORITY, MAIL_STATE_ICON.SYSTEM],
    ];
    let isExist = false;
    mutexconfig.forEach(item => {
        isExist = false;
        item.forEach(_ => {
            if (_iconList.includes(_)) {
                if (isExist) {
                    _iconList.splice(_iconList.indexOf(_), 1);
                }
                else {
                    isExist = true;
                }
            }
        });
    });
    return _iconList;
};
const filterIconListByMax = (folder, iconList) => {
    if ([FLOLDER.SENT].includes(folder)) {
        return iconList.slice(0, 2);
    }
    return iconList.slice(0, 3);
};
const sortIconListByUi = (folder, iconList) => {
    if ([FLOLDER.SENT].includes(folder)) {
        const sendFileUi = [
            MAIL_STATE_ICON.WITHDRAW_FAIL,
            MAIL_STATE_ICON.PARTIAL_WITHDRAW_SUCC,
            MAIL_STATE_ICON.WITHDRAW_SUCC,
            MAIL_STATE_ICON.RCPT_FAILED,
            MAIL_STATE_ICON.PARTIAL_RCPT_SUCCEED,
            MAIL_STATE_ICON.RCPT_SUCCEED,
            MAIL_STATE_ICON.PRIORITY,
        ];
        return sortArr(iconList, sendFileUi);
    }
    const otherFileUi = [
        MAIL_STATE_ICON.UNREAD,
        MAIL_STATE_ICON.SUSPICIOUS_MAIL,
        MAIL_STATE_ICON.POPREAD,
        MAIL_STATE_ICON.PRIORITY,
        MAIL_STATE_ICON.SYSTEM,
        MAIL_STATE_ICON.REPLAYED,
        MAIL_STATE_ICON.FORWARDED,
        MAIL_STATE_ICON.REPLAYED_AND_FORWARDED,
    ];
    return sortArr(iconList, otherFileUi);
};
const rulesHandler = (data, iconList) => {
    const { folder } = data.entry || {};
    const fidRes = filterIconListByFid(folder, iconList);
    const mailStateRes = filterIconListByMailState(data, fidRes);
    const priorityRes = sortIconListByPriority(folder, mailStateRes);
    const mutexRes = filterIconByMutex(priorityRes);
    const maxRes = filterIconListByMax(folder, mutexRes);
    const uiRes = sortIconListByUi(folder, maxRes);
    return uiRes;
};
const PriorityTag = props => {
    const { iconList, active = false, mid, _account } = props;
    const shouldAutoReadMail = mailConfApi.getShouldAutoReadMailSync();
    const handleUnreadIconClick = (ev) => {
        if (ev) {
            ev.preventDefault();
            ev.stopPropagation();
        }
        if (mid) {
            eventApi.sendSysEvent({
                eventName: 'mailStatesChanged',
                eventData: {
                    mark: true,
                    id: [mid],
                    type: 'read',
                },
                _account: _account || '',
                eventStrData: 'read',
            });
        }
    };
    return (React.createElement(React.Fragment, null, iconList.map((icon) => {
        const iconImg = iconConfig[icon].icon;
        const resEle = typeof iconImg === 'function' ? iconImg(active) : iconImg;
        const iconTip = iconConfig[icon].tooltip;
        const isUnreadIconAndShouldAutoReadMail = icon === MAIL_STATE_ICON.UNREAD && !shouldAutoReadMail;
        return (React.createElement(MyTooltip, { type: iconTip, key: icon, wrapClass: isUnreadIconAndShouldAutoReadMail ? 'mark-read-icon' : '', handleIconClick: isUnreadIconAndShouldAutoReadMail ? handleUnreadIconClick : undefined }, resEle));
    })));
};
const MailCardStateIcon = props => {
    const { data, active } = props;
    const allIconList = Object.values(MAIL_STATE_ICON);
    const iconList = useMemo(() => rulesHandler(data, allIconList), [data]);
    return (React.createElement(React.Fragment, null,
        React.createElement(PriorityTag, { iconList: iconList, active: active, mid: data.entry.id, _account: data._account })));
};
export default MailCardStateIcon;
